import { useTranslation } from '@web_opxp/features';
import React from 'react';
import { EAchievementType } from '../types';
import { getAchievementIconSrc, getAchievementTitle } from '../utils';
import './AchievementBadge.scss';

export interface IAchievementBadgeProps {
  type: EAchievementType;
  subType: number;
}

export const AchievementBadge: React.FC<IAchievementBadgeProps> = ({ type, subType }) => {
  const { t } = useTranslation();

  const imgSrc = getAchievementIconSrc(type, subType);
  const achievementTitle = getAchievementTitle(type, subType, t);
  if (!imgSrc || !achievementTitle) {
    return null;
  }
  return (
    <div className="achievement-badge-item">
      <div className="achievement-badge">
        <img className="achievement-badge-icon" src={imgSrc} alt={achievementTitle} />
        <small className="achievement-badge-name">{achievementTitle}</small>
      </div>
    </div>
  );
};

export default AchievementBadge;
